import { Controller } from "@hotwired/stimulus"

// O input de arquivo nativo não aceita moldura: o botão do navegador escapa
// da borda e cada sistema desenha o seu. Escondemos o input e usamos um label
// com a aparência dos nossos botões.
//
// Quando o formulário só serve para anexar, escolher o arquivo já envia: um
// botão de confirmar seria um segundo "ok" para a mesma decisão.
export default class extends Controller {
  static targets = [ "name" ]
  static values = { autoSubmit: Boolean }

  choose(event) {
    const files = Array.from(event.target.files || [])
    if (files.length === 0) return

    const names = files.map((file) => file.name).join(", ")
    if (this.hasNameTarget) this.nameTarget.textContent = names

    if (this.autoSubmitValue) this.element.closest("form").requestSubmit()
  }
}
